import { ServiceSchedules } from '@/service/schedules/serviceSchedules'

const serviceRecords = new ServiceSchedules()
export default {
  namespaced: true,
  state: {
    loading: false,
    getAvailableTime: [],
    selectedTimeSlots: [],
    time: {
      formattedStartTime: '',
      formattedEndTime: '',
    },
    interval: '',
    data: '',
  },
  actions: {
    async getAvailableTime({ commit, state }) {
      commit('SET_LOADING', true)
      const payload = {
        date: state.data,
        interval: state.interval,
        init_hour: state.time.formattedStartTime,
        final_hour: state.time.formattedEndTime,
      }

      try {
        const response = await serviceRecords.availableTimeSlots(payload)
        commit('SET_GET_AVAILABLE_TIME', response.data)
        commit('SET_SELECTED_TIME_SLOTS', response.data) // Pre-select all time slots
        commit('SET_LOADING', false)
      } catch (error) {
        commit('SET_LOADING', false)
        throw error
      }
    },
  },
  mutations: {
    SET_LOADING(state, payload) {
      state.loading = payload
    },
    SET_GET_AVAILABLE_TIME(state, payload) {
      state.getAvailableTime = payload
    },
    SET_SELECTED_TIME_SLOTS(state, payload) {
      state.selectedTimeSlots = payload // Set the selected time slots
    },
    ADD_SELECTED_TIME_SLOT(state, timeSlot) {
      state.selectedTimeSlots.push(timeSlot) // Add a time slot
    },
    REMOVE_SELECTED_TIME_SLOT(state, timeSlotKey) {
      state.selectedTimeSlots = state.selectedTimeSlots.filter(
        slot => `${slot.init_hour}-${slot.final_hour}` !== timeSlotKey,
      )
    },
    SET_AVAILABLE_TIME(state, payload) {
      state.time = payload
    },
    SET_INTERVAL(state, payload) {
      state.interval = payload
    },
    SET_DATA(state, payload) {
      state.data = payload
    },
  },
  getters: {
    getAvailableTime: state => state.time,
    getInterval: state => state.interval,
    getData: state => state.data,
    getAvailableTimeSlots: state => state.getAvailableTime,
    getSelectedTimeSlots: state => state.selectedTimeSlots,
  },
}
